module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container text-center mt-5"
  }, [_c('div', {
    staticClass: "center-block",
    staticStyle: {
      "max-width": "480px"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('UNLOCK_REQUEST_SENT_1')))]), _vm._v(" "), _c('h4', {
    staticClass: "mt-5"
  }, [_vm._v(_vm._s(_vm.$t('UNLOCK_REQUEST_SENT_2')))]), _vm._v(" "), _c('h4', {
    staticClass: "mt-3"
  }, [_vm._v(_vm._s(_vm.$t('UNLOCK_REQUEST_SENT_3')))]), _vm._v(" "), _c('div', {
    staticClass: "mt-5",
    staticStyle: {
      "margin-bottom": "120px"
    }
  }, [_c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'logowanie'
        })
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('GO_TO_MAIN_PAGE')) + "\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d0e7fae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/banned-account/unlock-request-sent.vue
// module id = 1179
// module chunks = 0